// LazyForms submission helper for Galaxy League.
//
// We send FormData (multipart/form-data) — a "simple" CORS request that the
// LazyForms endpoint accepts cross-origin (it returns { success: true }).
const LAZYFORMS_KEY = process.env.REACT_APP_LAZYFORMS_KEY;
const LAZYFORMS_ENDPOINT = LAZYFORMS_KEY
  ? `https://api.lazyforms.com/f/${LAZYFORMS_KEY}`
  : null;

async function postToLazyForms(fields) {
  if (!LAZYFORMS_ENDPOINT) {
    return { ok: false, message: "Konfigurationsfehler: Access Key fehlt." };
  }

  const fd = new FormData();
  Object.entries(fields).forEach(([key, value]) => fd.append(key, value ?? ""));

  try {
    const res = await fetch(LAZYFORMS_ENDPOINT, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
    });
    const json = await res.json();
    if (json && json.success) {
      return { ok: true };
    }
    return { ok: false, message: json?.message || "Unbekannter Fehler." };
  } catch (e) {
    return { ok: false, message: "Netzwerkfehler. Bitte erneut versuchen." };
  }
}

/**
 * Submit a team application to LazyForms.
 * @param {Object} data - structured form data
 * @returns {Promise<{ok: boolean, message?: string}>}
 */
export async function submitTeamApplication(data) {
  return postToLazyForms({
    _subject: `Galaxy League \u2013 Neue Bewerbung: ${data.teamName || "Team"}`,
    _honey: data.botcheck || "",
    "E-Mail": data.email || "",
    Vorname: data.firstName || "",
    Nachname: data.lastName || "",
    "Kapit\u00E4n Vorname": data.captainFirstName || "",
    "Kapit\u00E4n Nachname": data.captainLastName || "",
    Teamname: data.teamName || "",
    "Influencer-Plattform": data.influencerPlatform || "",
    "Influencer-Handle": data.influencerHandle || "",
    "Team-Status": data.teamTypeLabel || "",
  });
}

/**
 * Submit a general contact message to LazyForms.
 * @param {Object} data - { name, email, subject, message, botcheck }
 * @returns {Promise<{ok: boolean, message?: string}>}
 */
export async function submitContactMessage(data) {
  return postToLazyForms({
    _subject: `Galaxy League \u2013 Kontaktanfrage: ${data.subject || "Allgemein"}`,
    _honey: data.botcheck || "",
    Name: data.name || "",
    "E-Mail": data.email || "",
    Betreff: data.subject || "",
    Nachricht: data.message || "",
  });
}
